import { PageHeader } from "@/components/PageHeader";

interface PlaceholderPageProps {
  title: string;
}

export function PlaceholderPage({ title }: PlaceholderPageProps) {
  return (
    <>
      <PageHeader title={title} />
      <article className="panel">
        <p className="empty-state">
          This page will be ported from the existing Jinja template in a later
          phase. The layout, auth flow, and backend API for this section are
          all in place — the UI implementation is what's pending.
        </p>
      </article>
    </>
  );
}
